import { Dealer } from '../types/dealerTypes';
import {
  BASIS_POINTS_TO_MONEY_FACTOR,
  BASIS_POINTS_DECIMAL_PLACE_FACTOR,
} from './constants';

export const getNewInstorePriceSource = (dealer: Dealer) =>
  dealer.priceRules?.instore?.New?.defaultRule.priceSource;

export const getUsedInstorePriceSource = (dealer: Dealer) =>
  dealer.priceRules?.instore?.Used?.defaultRule.priceSource;

export const basisToMoneyDecimalConversion = (moneyFactor: number) => {
  // Used to remove unneeded decimals and limit displays decimals to 8 places.
  // This function works well until basis points reaches 5,000,000,000 which is unrealistic.
  return (
    Math.round(
      moneyFactor *
        BASIS_POINTS_TO_MONEY_FACTOR *
        BASIS_POINTS_DECIMAL_PLACE_FACTOR,
    ) / BASIS_POINTS_DECIMAL_PLACE_FACTOR
  );
};
